export const flattenMilestones = (milestones) => {
  let flattenedMilestones = [];

  milestones?.forEach((milestone) => {
    flattenedMilestones.push({ ...milestone });
    flattenedMilestones = [
      ...flattenedMilestones,
      ...flattenMilestones(milestone.childMilestones),
    ];
  });

  return flattenedMilestones;
};
